var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LPopup',[_c('h3',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.phone)?_c('div',[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'phone']}}),_vm._v("\n    "+_vm._s(_vm._f("formatPhone")(_vm.phone))+"\n  ")],1):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":("/location/" + _vm.slug + "/" + _vm.id),"data-testid":"popupLink"}},[_vm._v("\n    View details\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d2cda85","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationMarkerPopup.vue
// module id = 678
// module chunks = 0